import React, { useState } from "react";
import { accountService } from "../services/accountService";
import { Button, Form, FormGroup, Input } from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";
import Warning from "./Warning";
import { GoogleLogin } from "@react-oauth/google";

const Login = ({ setUser }: { setUser: Function }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [invalid, setInvalid] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setInvalid(false);

    if (email && password) {
      try {
        const user = await accountService.login(email, password);
        setUser(user);

        const from = (location.state as any)?.from?.pathname;
        if (from && from !== "/register" && from !== "/login") {
          navigate(from, { replace: true });
        } else {
          navigate("/", { replace: true });
        }
      } catch {
        setIsSubmitting(false);
        setInvalid(true);
      }
    } else {
      setIsSubmitting(false);
      setInvalid(true);
    }
  };

  const handleGoogleLogin = async (credentialResponse: any) => {
    setIsSubmitting(true);
    setInvalid(false);
    try {
       const token = credentialResponse.credential;
      const user = await accountService.loginWithGoogle(token);
      setUser(user);

      const from = (location.state as any)?.from?.pathname;
      if (from && from !== "/register" && from !== "/login") {
        navigate(from, { replace: true });
      } else {
        navigate("/", { replace: true });
      }
    } catch {
      setInvalid(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Form
      onSubmit={onSubmit}
      className="shadow-box"
      style={{ width: 400, maxWidth: "100%", margin: "auto" }}
    >
      <FormGroup>
        <Input
          autoComplete="username"
          onChange={(e) => setEmail(e.target.value.trim())}
          placeholder="Nazwa użytkownika lub email"
          type="text"
          name="email"
          id="loginEmail"
          required
        />
      </FormGroup>
      <FormGroup>
        <Input
          autoComplete="current-password"
          onChange={(e) => setPassword(e.target.value)}
          type="password"
          placeholder="Hasło"
          name="password"
          id="loginPassword"
          required
        />
      </FormGroup>
      {invalid && <Warning>Nazwa użytkownika lub hasło są niepoprawne</Warning>}

      {isSubmitting ? (
        <div className="spinner" />
      ) : (
        <>
          <Button className="single-btn w-100 mb-2" type="submit" disabled={isSubmitting}>
            Zaloguj
          </Button>
          <div style={{ display: "flex", justifyContent: "center", marginTop: 10 }}>
            <GoogleLogin
              onSuccess={handleGoogleLogin}
              onError={() => setInvalid(true)}
            />
          </div>
        </>
      )}

      <div className="text-end mt-2">
        <button
          type="button"
          className="btn btn-link p-0"
          style={{ color: "#494d50", textDecoration: "none" }}
          onClick={() => navigate("/forgot-password")}
        >
          Nie pamiętasz hasła?
        </button>
      </div>
    </Form>
  );
};

export default Login;
